const LIST_ALL_AGENTS = (state, payload) => {
  state.agents = payload;
}
const SET_CURRENT_AGENT = (state, payload) => {
  state.currentAgent = payload;
}

const SET_PRODUCT_LIST = (state, payload) => { state.productList = payload }
const RESET_PRODUCT_LIST = (state) => { state.productList = [] }

export default {
  LIST_ALL_AGENTS,
  SET_CURRENT_AGENT,
  SET_PRODUCT_LIST,
  RESET_PRODUCT_LIST,
}

